// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const AccountPanel = registerClientReference(
    function() { throw new Error("Attempted to call AccountPanel() from the server but AccountPanel is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/apps/web/src/components/auth/AccountPanel.tsx",
    "AccountPanel",
);
